// extracted by mini-css-extract-plugin
module.exports = {"chip":"NoCalcChip_chip__dwQeC"};